import Ajv from "ajv";

import dataSourceSchema from "./DataSource";
import { reportSchema, reportRequestSchema } from "./Report";
import subnetSchema from "./Subnet";
import labelSchema from "./Label";
import blocklistEntrySchema from "./BlocklistEntry";
import blocklistSchema from "./Blocklist";
import locationSchema from "./Location";
import { searchFilterSchema } from "./DataQuery";
import querySchema from "./Query";
import columnSchema from "./Column";
import categorySchema from "./Category";
import { logtypeSchema } from "./Logtype";
import queryResultSchema from "./QueryResult";
import orgLogTypeSchema from "./OrgLogType";
import ruleSchema, { conditionSetEntrySchema } from "./Rule";
import allowlistEntrySchema from "./AllowlistEntry";
import conditionSchema from "./Condition";
import findingSchema from "./Finding";
import orgSchema from "./Org";
import userSchema from "./User";
import meSchema from "./Me";
import constantsSchema from "./Constants";
import messageSchema from "./Message";
import settingsSchema from "./Settings";
import BQSchema from "./BQ";
import workflowStepSchema from "./WorkflowStep";
import actionSchema from "./Action";
import findingTypeSchema from "./FindingType";
import matchSchema from "./Match";

import { resultParamsSchema } from "./Request";
import { integrationSchema } from "./Integration";
import { integrationSchemaSchema } from "./IntegrationSchema";
import { orgColumnStatsSchema } from "./OrgColumnStats";
import signUpSchema from "./SignUp";

import lcAgentSchema from "./LCAgent";
import lcGroupSchema from "./LCGroup";

const Schema = new Ajv({
  schemas: [
    blocklistEntrySchema,
    blocklistSchema,
    categorySchema,
    columnSchema,
    dataSourceSchema,
    //dataQuerySchema,
    querySchema,
    labelSchema,
    locationSchema,
    logtypeSchema,
    reportSchema,
    reportRequestSchema,
    searchFilterSchema,
    subnetSchema,
    queryResultSchema,
    orgLogTypeSchema,
    ruleSchema,
    allowlistEntrySchema,
    conditionSetEntrySchema,
    conditionSchema,
    findingSchema,
    orgSchema,
    userSchema,
    meSchema,
    constantsSchema,
    messageSchema,
    resultParamsSchema,
    settingsSchema,
    BQSchema,
    integrationSchema,
    integrationSchemaSchema,
    orgColumnStatsSchema,
    signUpSchema,
    workflowStepSchema,
    actionSchema,
    findingTypeSchema,
    matchSchema,
    lcAgentSchema,
    lcGroupSchema,
  ],
  nullable: true,
  allErrors: true,
});

Schema.addFormat("bytes", {
  type: "array",
  validate: (byteArray) =>
    !byteArray.find((x) => x >= 0 && x <= 255 && x % 1 === 0),
});

export default Schema;
